require("./lib");

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./lib/vuetify";
import veevalidate from "./lib/veevalidate";
import VueExcelXlsx from "./lib/VueExcelXlsx";
import registerServiceWorker from "./lib/register-service-worker";

Vue.config.productionTip = false;

(async () => {
  await store.dispatch("get_user");
  const vm = new Vue({
    router,
    store,
    vuetify,
    veevalidate,
    VueExcelXlsx,
    render: (h) => h(App),
  }).$mount("#app");

  registerServiceWorker(vm);
})();
